import {AppState} from '../states/app.state';
import {createSelector} from '@ngrx/store';
import {KundeEntitiesSelectors} from './kunde-entities.selectors';
import {identity} from 'rxjs';
import {FakturierungsbelegFormSelectors} from './fakturierungsbeleg-form.selectors';
import {canReceiveGutschrift, isGutschrift} from '../../util/typeguards';


export class KontaktSelectors {

  /**
   * Die `select`-Eigenschaft ist ein Objekt, das Funktionen definiert, jede Funktion selektiert eine
   * bestimmte Eigenschaft aus dem State.
   * Das sind grundlegende Selektoren, die im ganzen Projekt als Bausteine für komplexere Selektoren wiederverwendet
   * werden können.
   */
  private static select = {
    displayedIds: (state: AppState) => state.kontakt.displayedIds,
    filterDto: (state: AppState) => state.kontakt.filterDto,
    pageableDto: (state: AppState) => state.kontakt.pageableDto,
    readMoreKunden: (state: AppState) => state.kontakt.readMoreKunden,
    loading: (state: AppState) => state.kontakt.loading,
    hasMorePages: (state: AppState) => state.kontakt.hasMorePages,
  };

  public static displayedAbsender = createSelector(
    this.select.displayedIds,
    KundeEntitiesSelectors.all,
    (selectedIds, kundeDto) =>
      KundeEntitiesSelectors.kundenByIds(selectedIds).projector(kundeDto)
  );

  /**
   * Die geladenen Kontakte, eingeschraenkt auf die fuer die aktuelle Belegart zulaessigen.
   * Bei der Gutschrift bleiben nur Geschaeftskontakte mit Sitz in Deutschland.
   */
  public static selectableKunden = createSelector(
    this.displayedAbsender,
    FakturierungsbelegFormSelectors.belegart,
    (kunden, belegart) => isGutschrift(belegart) ? kunden.filter(canReceiveGutschrift) : kunden,
  );

  public static filterDto = createSelector(
    this.select.filterDto,
    identity,
  );

  public static pageableDto = createSelector(
    this.select.pageableDto,
    identity,
  );

  public static readMoreKunden = createSelector(
    this.select.readMoreKunden,
    identity,
  );

  public static loading = createSelector(
    this.select.loading,
    identity,
  );

  public static hasMorePages = createSelector(
    this.select.hasMorePages,
    identity,
  );

  /**
   * Der Server kann noch Seiten liefern oder eine ist unterwegs: Ob ueberhaupt ein
   * auswaehlbarer Kontakt existiert, ist dann noch nicht entschieden.
   */
  public static listIncomplete = createSelector(
    this.loading,
    this.hasMorePages,
    (loading, hasMorePages) => loading || hasMorePages,
  );
}
